import React from 'react';
import { Backdrop } from '@mui/material';
import { Box } from "@mui/material";
import './LoadingScreen.css';

const LoadingScreen = ({ loading }) => {
    return (
        <Backdrop
            sx={{
                color: '#fff',
                zIndex: (theme) => theme.zIndex.drawer + 9999,
                backgroundColor: 'rgba(0, 0, 0, 0.4)', // Set opacity to 0.5
            }}
            open={loading} // Show or hide the loading screen based on the "loading" prop
        >
            <Box sx={{
                textAlign: 'center',
            }}>
                <div className="spin" style={{ width: '100px', height: '100px' }}>
                    <img
                        src={process.env.PUBLIC_URL + '/assets/entras.svg'}  // Add PUBLIC_URL
                        alt="Logo"
                        style={{
                            width: '100%',
                            height: '100%',
                        }}
                    />
                </div>
            </Box>
        </Backdrop>
    );
};

export default LoadingScreen;
